import UserSettingsPanel from '../panelComponents/UserSettingsPanel';
import withUserNotifications from '../hocs/withUserNotifications';

export default withUserNotifications(UserSettingsPanel);
